export default Marionette.View.extend({
    template: _.noop
});
